import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import CIMSSection from 'components/CIMSSection'

const RenderFormItems: React.VFC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  return (
    <>
      <CIMSSection
        title={`Every ${event.name} Event`}
        help={HelpMessage.Notifications.Every(event, 'Engineering Judgement')}
      >
        <CIMSFormItem label="Recipients" name="every">
          <RecipientsSelect />
        </CIMSFormItem>
      </CIMSSection>
    </>
  )
}

export default RenderFormItems
